import authService from "./authService";
import SecureCookieManager from '../utils/secureCookie';

const BASE_URL = process.env.REACT_APP_API_URL;


function getToken() {
    return SecureCookieManager.getAuthToken();
}
      

// Original function (kept for existing consumers)
export async function fetchAllSurveyDataApi(searchQuery: string = "", options: RequestInit = {}): Promise<any> {

    const token = getToken();
   
    const url = searchQuery 
      ? `${BASE_URL}/surveys/all?search=${encodeURIComponent(searchQuery)}`
      : `${BASE_URL}/surveys/all`;
   
    try {
      const response =await authService.apiCall(url, {
        ...options,
       
      });
  
      const data = await response.json();
  
      if (!response.ok ) {
        if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
          throw new Error("Forbidden: You do not have permission to access this resource.");
        }
        throw new Error("Failed to fetch");
      }
      return data;
    } catch (error: any) {
      //////console.log(error)
      throw new Error(error);
    }
  }

// New paginated function for IntialAssessment page
export async function getSurveysPaged(query: string = "", perPage: number = 10, pageNo: number = 0, options: RequestInit = {}): Promise<any> {
  const params = new URLSearchParams();
  if (query) params.set('query', query);
  params.set('perPage', String(perPage));
  params.set('pageNo', String(pageNo));
  const url = `${BASE_URL}/surveys?${params.toString()}`;

  try {
    const response = await authService.apiCall(url, {
      ...options,
      method: options.method || 'GET'
    });

    const data = await response.json();

    if (!response.ok) {
      if (response.status === 401 || response.status === 403 || data.message === "Forbidden access") {
        throw new Error("Forbidden: You do not have permission to access this resource.");
      }
      throw new Error(data?.message || "Failed to fetch");
    }

    return data; // { data, totalPages, totalCount }
  } catch (error: any) {
    throw new Error(error);
  }
}

export async function registerSurveyBulk(formData: FormData): Promise<any> {
  const token = getToken();


  const response = await authService.apiCall(`${BASE_URL}/surveys/import-excel`, {
    method: "POST",
  
    body: formData,
  
  });

  const data = await response.json();
  return data;
}